import type { Row } from '../../types'

export const sortByLockOrComingSoonAndValue = (
  rowA: Row,
  rowB: Row,
  columnId: string,
): number => {
  const { _locked: lockedA, _isComingSoon: comingSoonA } = rowA.original
  const { _locked: lockedB, _isComingSoon: comingSoonB } = rowB.original

  // 1. Non-locked, non-coming soon rows first
  if (!lockedA && !comingSoonA && (lockedB || comingSoonB)) return -1
  if ((lockedA || comingSoonA) && !lockedB && !comingSoonB) return 1

  // 2. Coming soon rows next (both rows are not locked, but one is coming soon)
  if (!lockedA && comingSoonA && lockedB && !comingSoonB) return -1
  if (!lockedB && comingSoonB && lockedA && !comingSoonA) return 1

  // 3. Locked rows last
  if (lockedA && !lockedB) return 1
  if (lockedB && !lockedA) return -1

  // 4. If both rows are in the same category, sort by column value
  const a = rowA.original[columnId]
  const b = rowB.original[columnId]
  return a > b ? 1 : a < b ? -1 : 0
}

export default sortByLockOrComingSoonAndValue
